<template>
  <div class="city-container">
    <div class="patrol-banner">
      <img
        src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/index/programme_img4.png"
        alt="" class="pc-banner" />
      <img
        src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/product/city_banner.png"
        alt="" class="mobile-banner" />
      <div class="text-block">
        <div class="title wow fadeInUp" data-wow-duration="0.8s" data-wow-delay="0.2s">
          城市网格化巡逻
        </div>
        <div class="desc wow fadeInUp" data-wow-delay="0.5s">
          打造低空“星链”，提升城市综合管理能力
        </div>
      </div>
    </div>


    <div class="industry-block type-block" style="max-width:100%;">
      <div class="industry-title page-block-title">传统巡逻方式及问题</div>
      <div class="industry-content pc-carousel">
        <div class="industry-item">
          <img
            src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/patrol_problem.png"
            alt="" />
          <div class="text-block">
            <div class="title">数据收集不全面</div>
            <div class="desc">传统巡查方式多依赖于巡逻人员的肉眼观察和手工记录，容易出现遗漏和误差</div>
          </div>
        </div>

        <div class="industry-item">
          <img
            src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/patrol_problem1.png"
            alt="" />
          <div class="text-block">
            <div class="title">响应速度慢</div>
            <div class="desc">应对突发事件时，如火灾、自然灾害等，传统巡逻方式往往难以迅速到达现场并了解情况</div>
          </div>
        </div>

        <div class="industry-item">
          <img
            src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/patrol_problem2.png"
            alt="" />
          <div class="text-block">
            <div class="title">人力成本高</div>
            <div class="desc">传统巡逻方式需要大量的人力投入，不仅增加了管理成本，还可能导致人力资源的浪费</div>
          </div>
        </div>
      </div>
      <mobileCarousel class="mobile-carousel"></mobileCarousel>
    </div>

    <div class="solve-progress-block">
      <div class="solve-title page-block-title">解决思路</div>
      <div class="solve-progress-content">
        <!-- <img
          src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/patrol_flow_img.png"
          style="width:100%;" alt="" /> -->
        <img
          src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/product/patrol_flow_img.png"
          style="width:85%;margin:0 auto;" alt="" />
      </div>
      <div class="mobile-progress-content">
        <img src="../../assets/images/patrol_flow_city_img.png" style="width:21.5rem;" alt="" />
      </div>
    </div>

    <div class="case-advantage-wrap">
      <div class="case-advantage-title page-block-title">我们的优势</div>
      <div class="case-advantage-content">
        <div class="case-advantage-block">
          <img
            src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/advantage_icon1.png"
            alt="">
          <div class="advantage-title">巡逻视域时域全覆盖</div>
          <div class="case-advantage-desc">无人机网格化巡逻实现全市范围的高频次、全时段巡逻，确保每个网格区域得到有效监控。</div>
        </div>

        <div class="case-advantage-block">
          <img
            src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/advantage_icon2.png"
            alt="">
          <div class="advantage-title">应急响应更快</div>
          <div class="case-advantage-desc">实时数据与智能分析系统提供即时反馈，能够迅速响应突发事件，提高应急处理能力。</div>
        </div>

        <div class="case-advantage-block">
          <img
            src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/advantage_icon3.png"
            alt="">
          <div class="advantage-title">防范能力更强</div>
          <div class="case-advantage-desc">AI系统对异常行为进行自动预警，帮助提前识别潜在风险，提升安全防范能力。</div>
        </div>
      </div>
    </div>

    <!-- 应用场景 -->
    <div class="application-scenarios">
      <div class="application-title page-block-title">应用场景</div>
      <div class="application-desc page-block-desc">全市范围内实现无人机智能巡逻网络的全面部署。 提升对城市建设执法、城管执法、社会治安和罂粟查处等方面的管理能力。
        形成数据驱动的决策系统，优化城市综合管理水平。
      </div>
      <div class="application-content">
        <div class="application-block">
          <img
            src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/scene_img1.png"
            class="pc-img" alt="">
          <img
            src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/mobile/scene_img1.png"
            class="mobile-img" alt="">
          <div class="text">城市违建</div>
        </div>

        <div class="application-block">
          <img
            src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/scene_img2.png"
            class="pc-img" alt="">
          <img
            src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/mobile/scene_img2.png"
            class="mobile-img" alt="">
          <div class="text">城管执法</div>
        </div>

        <div class="application-block">
          <img
            src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/scene_img3.png"
            class="pc-img" alt="">
          <img
            src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/mobile/scene_img3.png"
            class="mobile-iimg" alt="">

          <div class="text">社会治安</div>
        </div>

        <div class="application-block">
          <img
            src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/scene_img4.png"
            class="pc-img" alt="">
          <img
            src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/mobile/scene_img4.png"
            class="mobile-iimg" alt="">

          <div class="text">河道巡检</div>
        </div>

        <div class="application-block">
          <img
            src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/scene_img5.png"
            class="pc-img" alt="">
          <img
            src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/mobile/scene_img5.png"
            class="mobile-iimg" alt="">
          <div class="text">火情处理</div>
        </div>

        <div class="application-block">
          <img
            src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/scene_img6.png"
            class="pc-img" alt="">
          <img
            src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/mobile/scene_img6.png"
            class="mobile-iimg" alt="">
          <div class="text">罂粟花查处</div>
        </div>
      </div>
    </div>


  </div>
</template>

<script>
import { WOW } from "wowjs";
import mobileCarousel from './components/city-patrol-carousel.vue'
export default {
  components: {
    mobileCarousel
  },
  data() {
    return {};
  },
  mounted() {
    this.$nextTick(() => {
      new WOW().init();
    });
  },
};
</script>

<style lang="stylus" scoped>
.city-container {
    width:100%;
    @keyframes zoomIn {
            0% {
              transform: scale(1.1); 
            }
            100% {
                transform: scale(1); 
            }
        }
    .patrol-banner {
        height:100vh;
        margin-top:80px;
        position:relative;
        img {
          height:100%;
          width: 100%;
          object-fit: cover;
          position: absolute;
          top: 0;
          left: 0;
          z-index: 1;
          transition: transform 0.3s ease-out;
          animation: zoomIn 3s ease-out forwards;
        }
        .text-block {
            position:absolute;
            top:50%;
            left:50%;
            transform: translate(-50%,-50%);
            margin-top:-107px;
            z-index: 2;
            color:#fff;
            text-align:center;
            .title {
                font-size:3rem;
                letter-spacing: 2px;
                font-weight: bold;
                margin-bottom:1.44rem;
            }
            .desc {
                letter-spacing: 2px;
                width:734px;
                white-space: wrap;
                font-size:1.25rem;
                line-height:35px;
            }
        }
    }
    .type-block {
        margin-top:3.375rem !important;
    }

    .industry-block {
        max-width:var(--main-width);
        width:84%;
        margin:0 auto 4.93rem;
        .industry-title {
            position:relative;
            position:relative;
            text-align:center;
        }
    .mobile-carousel {
      display:none;
    }
    .industry-content {
        display:flex;
        margin-top:4.56rem;
        flex-wrap:wrap;
        justify-content:center;
        .industry-item:not(:last-child) {
          margin-right:30px;   
        }
        .industry-item {
            width:25%;
            img {
                margin-bottom:0.875rem;
                width:100%;
            }
            .text-block {
                text-align:center;
                .title {
                    font-size:1.375rem;
                    font-weight:bold;
                    margin-bottom:10px;
                    color:#333;
                }
                .desc {
                 color:#666666;
                 font-size:14px;
                }
            }
        }
    }
    }
    .solve-progress-block {
        background-image:url("https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/patrol_bg.png");
        background-size:cover;
        padding-top:2.68rem;
        padding-bottom:7.25rem;
        margin:0 auto;
        color:#333333;
        .solve-title {
            position:relative;
            text-align:center;
            letter-spacing:1px;
            margin-bottom:3.18rem;
        }
    .solve-desc {
        text-align: center;
        margin:0 auto;
        letter-spacing: 1px;
        line-height:25px;
    }
    .solve-progress-content {
        max-width:var(--main-width);
        width:84%;
        margin:5.37rem auto 0;
        display:flex;
        justify-content:center;
    }
    .mobile-progress-content {
      display:none;
    }
    }

    .application-scenarios {
        margin-top: 4.38rem;
      .mobile-img {
        display:none;
      }
        .application-title {
            position:relative;
            text-align:center;
            letter-spacing:1px;
            margin-bottom:3.18rem;
        }
       
        .application-desc {
            text-align: center;
            margin:0 auto;
            letter-spacing: 1px;
            width:55.5rem;
            line-height:25px;
        }
        .application-content {
            display:flex;
            justify-content: space-around;
            gap: 1.875rem;
            flex-wrap: wrap;
            max-width:var(--main-width);
            width:84%;
            margin:2.375rem auto 7.5rem;
            .application-block {
                flex:0 0 calc(33.33% - 1.875rem);
                max-width:380px;
                box-sizing:border-box;
                position:relative;
                display:flex;
                justify-content: center;
                align-items:center;
                overflow:hidden;
                img {
                  width:100%;
                  height:auto;
                }
                .text {
                    position:absolute;
                    bottom:0px;
                    width:100%;
                    color:#fff;
                    text-align: center;
                    line-height: 87px;
                    background: linear-gradient( 180deg, rgba(39,39,39,0) 0%, rgba(14,14,14,0.7) 100%);
                }
            }
            .mobile-iimg {
              display:none;
            }
        }
    }
}
.case-advantage-wrap {
    padding:5.18rem 0 0rem;
    .case-advantage-title {
            position:relative;
            text-align:center;
            letter-spacing:1px;
            color:#333;
            margin-bottom:3.18rem;
        }
    .case-advantage-content {
        display:flex;
        max-width:var(--main-width);
        width:84%;
        margin:3.68rem auto 0;
        justify-content: space-around;
    }
    .case-advantage-block:hover {
      background: #F5F7FA;
      border-radius: 0.75rem 0.75rem 0.75rem 0.75rem;
      .advantage-title {
        color:#2372E9;
      }
      .advantage-title::after {
        background-color:#2372E9 !important;
      }
    }
    .case-advantage-block {
        position:relative;
        text-align: center;
        display:flex;
        justify-content: center;
        flex-direction: column;
        align-items: center;
        padding:3.61rem 0 3.75rem;
        width:21.25rem;
        .advantage-title {
            margin-top:10px;
            color:#222;
            font-weight:bold;
            font-size:1.375rem;
            position:relative;
            margin-bottom:2.5rem;
        }
        .advantage-title::after {
            position:absolute;
            content:"";
            bottom:-20px;
            left:50%;
            transform: translateX(-50%);
            width: 40px;
            height:1px;
            background-color: #666666;
        }
        .case-advantage-desc {
            color:#666666;
            line-height:25px;
            max-width:17.5rem;
            font-size:14px;
        }
    }
}

@media only screen and (max-width: 768px) {
  .city-container {
  .patrol-banner {
    height:380px;
    margin-top:108px;
    .text-block {
      margin-top:0 ;
      width:80%;
      .title {
        font-size:24px;
        margin-bottom:10px;
      }
      .desc {
        width:100%;
        font-size:14px;
        line-height:18px;
      }
    }
    }
    .city-container {
      .type-block {
      margin-top:0px !important;
    }
    }
    .industry-block{
    padding:25px 12px 0;
    max-width:100% !important;
    width:auto !important;
    margin:0 !important;
    .carousel {
      margin:16px 0 24px;
    }

    .industry-title {
      font-size:22px;
      margin-top:0px !important;
      font-weight:bold;
    }
    .industry-title::after {
      top:50px !important;
    }
    .industry-content {
      display:none !important;
      // flex-wrap:wrap;
      // justify-content:center;
      // margin-top:40px !important;
      // .industry-item {
      //   // width:50%;
      // }
    }
  }
  .solve-progress-block {
      height:650px !important;
      padding-bottom:0px !important;
      .solve-progress-content {
        display:none;
      }
      .mobile-progress-content {
        display: flex !important;
        justify-content: center;
      }
      .solve-title {
        font-size:22px !important;
        margin-top:0px !important;
        font-weight:bold;
    }
    .solve-desc {
      display:none;
    }
    .solve-title::after {
      top:50px !important;
    }
    }
    .application-scenarios {
      margin-top:0px !important;
      padding:0 15px;
      .application-content {
        width:100% !important;
        gap:0 !important;
        margin:2.375rem auto !important;
      }
      .pc-img {
        display:none !important;
      }
      .mobile-img {
        display:block !important;
      }
      .application-title {
        font-size:22px;
        margin-top:0px;
        font-weight:bold;
        margin-bottom:15px;
      }
      .application-title::after {
        top:50px !important;
      }
      .application-desc {
        font-size:14px;
        color:#666;
        width:100%;
      }
      .application-block {
        max-width:30% !important;
        min-width:30% !important;
        margin-bottom:20px;
        .text {
          width:108px !important;
          line-height:25px !important; 
        }
      }
      
    }
    .case-advantage-wrap {
      padding:5.18rem 0 2.125rem;
      .case-advantage-title {
        font-size:22px;
        margin-top:0px;
        font-weight:bold;
      }
      .case-advantage-title::after {
        top:50px !important;
      }
      .case-advantage-content {
        flex-wrap:wrap !important;
        width:100%;
        margin:3.68rem auto 0;
        .case-advantage-block {
          margin-bottom:30px;
          padding:0;
          width:80%;
          .advantage-title {
            font-size:18px;
         }
         .case-advantage-desc {
           font-size:13px;
           color:#666;
           line-height:19px;
           width:100%;
           max-width:100%;
          }
        }
      }
    }
    .mobile-carousel {
      display:block !important;
    }
    .pc-carousel {
      display:none;
    }
    .mobile-iimg {
      display:block !important;
    }
    }
}
</style>
